export function getFileNameFromPath(filePath: string): string {
  if (!filePath) {
    return '';
  }

  // Use this when the backend gives a full file path and the UI only needs the file name.
  // It handles both Windows-style (\) and URL-style (/) separators.
  const normalizedPath = filePath.replace(/\\/g, '/');
  const lastSeparatorIndex = normalizedPath.lastIndexOf('/');

  return lastSeparatorIndex >= 0
    ? normalizedPath.substring(lastSeparatorIndex + 1)
    : normalizedPath;
}
